import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Paper from "@mui/material/Paper";
import {
  recommendationsTabelData,
  RLMUActionsTabelData,
} from "../../constants/sampleData";
import CommonButton from "../CommonButton";
import RecommendationModal from "../Modal/RecommendationModal";
import { useDispatch, useSelector } from "react-redux";
import { recommendationActionApi } from "../../Services/approval.service";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";
import useToaster from "../../customHook/useToaster";
import { Fragment } from "react";
import { Collapse, Grid } from "@mui/material";
import RegulatoryDetails from "./RegulatoryDetails";
import { Box } from "@mui/system";
import PeerReview from "./PeerReview";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "#CDF0DD",
    // color: theme.palette.common.white,
    fontSize: "1.1rem",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "1.1rem",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // '&:nth-of-type(odd)': {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // // hide last border
  // '&:last-child td, &:last-child th': {
  //   border: 0,
  // },
}));

const reportStandardColors = {
  excellent: {
    background: "#C5F5D9",
    color: "#0C7436",
  },
  "very good": {
    background: "#D7F5F5",
    color: "#207A7A",
  },
  good: {
    background: "#CCE6FF",
    color: "#004F99",
  },
  fair: {
    background: "#FFE7CC",
    color: "#9A5201",
  },
  average: {
    background: "#FFF2CD",
    color: "#684E01",
  },
  "below average": {
    background: "#FFD6CC",
    color: "#991F01",
  },
};

const backgroundColorTabelData = {
  Hospital: "#CDF0DD",
  Garage: "#FEEFB6",
  Submitted: "#fcd3de",
  QC: "#cdf0dd",
  Recommended: "#feefb6",
  Rejected: "#cddafc",
};

const RecommendationTabelGrid = ({
  selectedCaseData = {},
  gridContent = {},
  firstTabVal = "",
  secondTabVal = "",
  setIsSubmitActive = () => {},
  setRerenderSegmentApiState = () => {},
  onClickSubmitHandler = () => {},
}) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [onClickValue, setOnClickValue] = React.useState("");
  const [rowNumber, setRowNumber] = React.useState(0);
  const [rowStatus, setRowStatus] = React.useState([]);
  const currentRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const dispatch = useDispatch();
  const { showToast } = useToaster();

  let tableData = "";
  let blacklistApprovalRecord = "";
  let masterName = "";
  if (firstTabVal === "Hospital" && secondTabVal === "Recommendation") {
    blacklistApprovalRecord = "blacklistHospitalApprovalRecord";
    masterName = "hospital_master";
  } else if (firstTabVal === "Garage" && secondTabVal === "Recommendation") {
    blacklistApprovalRecord = "blacklistGarageApprovalRecord";
    masterName = "garage_master";
  } else if (secondTabVal === "FCU Actions") {
    blacklistApprovalRecord = "rlmu";
  }
  if (secondTabVal === "Recommendation") {
    tableData = recommendationsTabelData;
  } else if (secondTabVal === "FCU Actions") {
    tableData = RLMUActionsTabelData;
  }

  const openModalHandler = (key, rowvalue) => {
    setOnClickValue(key);
    setOpenModal(true);
    setRowNumber(rowvalue);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const actionHandler = (id, decision_id, decision) => {
    if (selectedCaseData?.flag === "false") {
      return showToast("Case already submitted.", "info", true);
    }
    let payload = {
      caseId,
      decision, //1 for approve and 0 for reject
      [`${firstTabVal.toLowerCase()}_id`]: id,
      [`${firstTabVal.toLowerCase()}_decision_id`]: decision_id,
    };
    dispatch(isLoadingStateReducer(true));
    recommendationActionApi(firstTabVal, payload)
      ?.then((data) => {
        if (data?.success) {
          if (data?.data?.decision === 0) {
            showToast("Rejected Successfully", "success", true);
          } else if (data?.data?.decision === 1) {
            showToast("Approved Successfully", "success", true);
          }
          // setIsSubmitActive(true);
          setRerenderSegmentApiState((prev) => !prev);
          dispatch(isLoadingStateReducer(false));
        }
      })
      ?.catch((err) => {
        dispatch(isLoadingStateReducer(false));
        showToast(err?.response?.data?.message, "error", true);
      });
  };

  const approveHandler = (index) => {
    const updatedRowStatus = [...rowStatus];
    updatedRowStatus[index] = {
      ...updatedRowStatus[index],
      isReject: true,
    };
    setRowStatus(updatedRowStatus);
    setIsSubmitActive(true);
  };

  const rejectHandler = (index) => {
    const updatedRowStatus = [...rowStatus];
    updatedRowStatus[index] = {
      ...updatedRowStatus[index],
      isApproved: true,
    };
    setRowStatus(updatedRowStatus);
    setIsSubmitActive(true);
  };

  const Row = ({ item, index }) => {
    const [viewButtonState, setViewButtonState] = React.useState({
      open: false,
      selectedValue: "",
    });
    const getViewItemComponent = (key, item) => {
      const componets = {
        regulatory_details: (
          <RegulatoryDetails
            data={item?.regulatory_details || {}}
            viewOnly={true}
          />
        ),
        peer_review: <PeerReview data={item} />,
      };
      return componets[key];
    };

    return (
      <Fragment>
        <StyledTableRow>
          {Object.keys(tableData?.[firstTabVal]?.row)?.map((key) => (
            <StyledTableCell
              key={key}
              component="th"
              scope="row"
              style={{
                color:
                  item?.[key] === true
                    ? "#0C7436"
                    : item?.[key] === false
                    ? "#991F01"
                    : "inherit",
                textAlign:
                  key === "vendor_assessment" && viewButtonState?.open
                    ? "inherit"
                    : "inherit",
                padding: secondTabVal === "FCU Actions" ? "11px" : "16px",
              }}
            >
              {key === "SrNo" ? (
                index + 1
              ) : key === "hsaddress1_var" ? (
                <span style={{ position: "relative" }}>
                  {/* {item?.[masterName][key].split(key)[0]} */}

                  <span
                    style={{
                      textDecoration: "underline",
                      textDecorationColor: "#396AF2",
                      color: "#396AF2",
                      cursor: "pointer",
                    }}
                    onClick={() => openModalHandler(key, index)}
                  >
                    Address
                    {/* {item?.[masterName][key]} */}
                  </span>
                  {rowNumber === index && openModal && (
                    <RecommendationModal
                      modalHeadText="Address :"
                      modalBodyText={item?.[masterName]?.[key]}
                      openModal={openModal}
                      setOpenModal={setOpenModal}
                      handleClose={handleCloseModal}
                      onClickValue={onClickValue}
                    />
                  )}
                </span>
              ) : tableData?.UserRoleMapping?.[key] === currentRole &&
                selectedCaseData?.flag === "true" ? (
                <div style={{ display: "flex", gap: "1.5rem" }}>
                  <button
                    style={{
                      background: item?.[key] === false ? "#9A9A9A" : "#04B74C",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      border: "0",
                      cursor: "pointer",
                    }}
                    // disabled={item[key] === false}
                    // disabled={
                    //   rowStatus[index]?.isApproved ? true : false
                    // }
                    // onClick={() => approveHandler(index)}
                    onClick={() =>
                      actionHandler(
                        item?.[masterName]?.[
                          `${firstTabVal?.toLowerCase()}_id`
                        ],
                        item?.[
                          `${firstTabVal?.toLowerCase()}_blacklist_decisions_id`
                        ],
                        1
                      )
                    }
                  >
                    Approve
                  </button>
                  <button
                    style={{
                      background: item?.[key] === true ? "#9A9A9A" : "#DE0005",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      border: "0",
                      cursor: "pointer",
                    }}
                    // disabled={item[key] === true}
                    // disabled={rowStatus[index]?.isReject ? true : false}
                    // onClick={() => rejectHandler(index)}
                    onClick={() =>
                      actionHandler(
                        item?.[masterName]?.[
                          `${firstTabVal?.toLowerCase()}_id`
                        ],
                        item?.[
                          `${firstTabVal?.toLowerCase()}_blacklist_decisions_id`
                        ],
                        0
                      )
                    }
                  >
                    Reject
                  </button>
                </div>
              ) : item[key] === true ? (
                "Approved"
              ) : item[key] === false ? (
                "Rejected"
              ) : secondTabVal === "FCU Actions" &&
                (key === "vendor_assessment" ||
                  key === "regulatory_details" ||
                  key === "peer_review") ? (
                <span>
                  {viewButtonState?.open &&
                  viewButtonState?.selectedValue === key ? (
                    <KeyboardArrowUpIcon
                      id={key}
                      sx={{ fontSize: "2.5rem", cursor: "pointer" }}
                      onClick={(e) =>
                        setViewButtonState({
                          open: false,
                          selectedValue: "",
                        })
                      }
                    />
                  ) : (
                    <CommonButton
                      id={key}
                      label="View"
                      isColor
                      backgroundColor="#DE0005"
                      textColor={"white"}
                      removeBorder
                      isHover
                      hoverColor="#DE0005"
                      sx={{
                        padding: "0.1em 1.5rem",
                        width: "4rem",
                        height: "2rem",
                        borderRadius: "6px",
                        fontSize: "11px",
                      }}
                      onClick={(e) => {
                        setViewButtonState({
                          open: false,
                          selectedValue: "",
                        });
                        setTimeout(() => {
                          setViewButtonState({
                            open: true,
                            selectedValue:
                              e?.target?.parentElement?.getAttribute("id"),
                          });
                        }, 0);
                      }}
                    />
                  )}
                </span>
              ) : secondTabVal === "FCU Actions" && item?.[key] ? (
                item?.[key]
              ) : item?.[masterName]?.[key] ? (
                item?.[masterName]?.[key]
              ) : (
                "-"
              )}
            </StyledTableCell>
          ))}
        </StyledTableRow>
        {secondTabVal === "FCU Actions" && (
          <StyledTableRow>
            <StyledTableCell
              colSpan={8}
              sx={{ padding: viewButtonState?.open ? "inherit" : "0px" }}
            >
              <Collapse
                in={viewButtonState?.open}
                timeout="auto"
                unmountOnExit
                sx={{
                  borderBottom:
                    viewButtonState?.selectedValue === "peer_review"
                      ? "1px solid #BFBFBF"
                      : "none",
                }}
              >
                {viewButtonState?.selectedValue === "vendor_assessment" ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        {Object?.entries(
                          tableData?.[firstTabVal]?.["vendorAssessments"]?.row
                        )?.map(([key, label], index, arr) => (
                          <StyledTableCell
                            key={key}
                            align=""
                            sx={{
                              borderRadius:
                                index === 0
                                  ? "1rem 0 0"
                                  : index === arr?.length - 1
                                  ? "0 1rem 0 0"
                                  : "unset",
                              minWidth: index === 2 ? "120px" : "none",
                            }}
                          >
                            <b>{label}</b>
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    {item?.vendorAssessments?.length > 0 ? (
                      item?.vendorAssessments?.map((item, index, arr) => (
                        <StyledTableRow
                          key={`rlmu-vendor-row-${index}`}
                          sx={{
                            borderBottom:
                              index === arr?.length - 1
                                ? "1px solid #bfbfbf"
                                : "0",
                          }}
                        >
                          {Object?.keys(
                            tableData?.[firstTabVal]?.["vendorAssessments"]?.row
                          )?.map((key) => (
                            <StyledTableCell
                              key={key}
                              component="th"
                              scope="row"
                              style={{
                                color:
                                  item[key] === true
                                    ? "#0C7436"
                                    : item[key] === false
                                    ? "#991F01"
                                    : "inherit",
                              }}
                            >
                              {key === "report_standard" ? (
                                // <div
                                //   style={{
                                //     width: "fit-content",
                                //     padding: "4px",
                                //     background: "rgba(215, 245, 245, 1)",
                                //     color: "#207A7A",
                                //     borderRadius: "6px",
                                //   }}
                                // >
                                <span
                                  style={{
                                    width: "fit-content",
                                    padding: "4px",
                                    background:
                                      reportStandardColors?.[
                                        item?.[key]?.toLowerCase()
                                      ]?.background,
                                    color:
                                      reportStandardColors?.[
                                        item?.vendorAssessments?.[
                                          key
                                        ]?.toLowerCase()
                                      ]?.color,
                                    borderRadius: "6px",
                                  }}
                                >
                                  {item?.[key]}
                                </span>
                              ) : (
                                item?.[key] || "-"
                              )}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <TableBody>
                        {["-"]?.map((val) => (
                          <StyledTableRow key="no_data">
                            {Object.keys(
                              tableData?.[firstTabVal]?.["vendorAssessments"]
                                ?.row
                            )?.map((key) => (
                              <StyledTableCell
                                key={key}
                                component="th"
                                scope="row"
                              >
                                {val}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    )}
                  </Table>
                ) : (
                  <Box sx={{ margin: 3 }}>
                    {getViewItemComponent(viewButtonState?.selectedValue, item)}
                    {viewButtonState?.selectedValue !== "peer_review" ? (
                      <hr
                        style={{
                          marginTop: "20px",
                          borderColor: "0.5px solid #BFBFBF",
                        }}
                      ></hr>
                    ) : (
                      ""
                    )}
                  </Box>
                )}
              </Collapse>
            </StyledTableCell>
          </StyledTableRow>
        )}
      </Fragment>
    );
  };

  return firstTabVal ? (
    <>
      <TableContainer
        sx={{
          overflowX: "unset",
          borderRadius: "1rem",
          boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {Object.entries(tableData?.[firstTabVal]?.row)?.map(
                ([key, label], index, arr) => (
                  <StyledTableCell
                    key={key}
                    align=""
                    sx={{
                      backgroundColor: backgroundColorTabelData[firstTabVal],
                      borderRadius:
                        index === 0
                          ? "1rem 0 0"
                          : index === arr?.length - 1
                          ? "0 1rem 0 0"
                          : "unset",
                    }}
                  >
                    {key.includes("decision") ? (
                      <span style={{ position: "relative" }}>
                        {label.includes("View Recommendation") ? (
                          <div>
                            <b>{label.split("View Recommendation")[0]}</b>
                            <br />
                            <span
                              style={{
                                textDecoration: "underline",
                                textDecorationColor: "#396AF2",
                                color: "#396AF2",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                              }}
                              onClick={() => openModalHandler(key)}
                            >
                              <b>View Recommendation</b>
                            </span>
                            {label.split("View Recommendation")[1]}
                          </div>
                        ) : (
                          <b>{label}</b>
                        )}
                        {onClickValue === key && openModal && (
                          <RecommendationModal
                            modalHeadText={`Recommendation by ${tableData?.UserRoleMapping?.[key]}`}
                            modalBodyText={
                              gridContent?.remarks[
                                `${tableData?.UserRoleMapping?.[
                                  key
                                ]?.toLowerCase()}_remark`
                              ]?.length
                                ? gridContent?.remarks[
                                    `${tableData?.UserRoleMapping?.[
                                      key
                                    ]?.toLowerCase()}_remark`
                                  ]
                                : "No Remark"
                            }
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            handleClose={handleCloseModal}
                            onClickValue={onClickValue}
                          />
                        )}
                      </span>
                    ) : (
                      <b>{label}</b>
                    )}
                  </StyledTableCell>
                )
              )}
            </TableRow>
          </TableHead>
          {gridContent?.[blacklistApprovalRecord]?.length > 0 ? (
            <TableBody>
              {gridContent?.[blacklistApprovalRecord]?.map((item, index) => (
                <>
                  <Row key={index} item={item} index={index} />
                </>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              {["-"]?.map((val) => (
                <StyledTableRow key="no_data">
                  {Object.keys(tableData?.[firstTabVal]?.row)?.map((key) => (
                    <StyledTableCell key={key} component="th" scope="row">
                      {val}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {secondTabVal !== "FCU Actions" &&
        firstTabVal !== "Submitted" &&
        firstTabVal !== "QC" &&
        firstTabVal !== "Recommended" &&
        firstTabVal !== "Hospital" &&
        firstTabVal !== "Garage" &&
        firstTabVal !== "Rejected" && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CommonButton
              label={"Submit"}
              onClick={onClickSubmitHandler}
              boxShadow={"rgba(0, 0, 0, 0.25)"}
              fontSize="1.4rem"
              sx={{
                width: "8%",
                backgroundColor: "#E8505B",
                marginTop: "4rem",
              }}
              isColor
              textColor={"white"}
              isHover
              hoverColor={"#E8505B"}
              removeBorder
            />
          </div>
        )}
    </>
  ) : (
    <Paper
      sx={{
        padding: "0px 16px 16px 16px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
      }}
      elevation={4}
    >
      <Grid container spacing={2} sx={{ margin: 0 }} rowSpacing={3}>
        <div
          style={{
            margin: "20px 7px",
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            color: "grey",
          }}
        >
          <h3>No data</h3>
        </div>
      </Grid>
    </Paper>
  );
};
export default RecommendationTabelGrid;
